import Select from 'react-select'
import Button from '../atoms/Button'
import css from './SearchBar.module.scss'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export default function SearchBar({
	canCreate = true,
	dataName = '',
	createFunction,
	createLink,
	onChange,
	value,
	options,
	view,
	selected,
	select,
}) {
	const [action, setAction] = useState()
	const { permissions } = useSelector(state => state.auth)

	return (
		<div className={css['controls']}>
			<div className={css['search']}>
				<input
					// DON'T FORGET TO REPLACE THIS
					onChange={onChange}
					placeholder={`Search for ${dataName}s`}
					// value={value}
				/>

				<Button
					label={`Create ${
						(dataName == 'item' && !permissions.create.includes('items')) ||
						(dataName == 'offer' && !permissions.create.includes('offers'))
							? 'Pending'
							: ''
					} ${dataName}`}
					iconLeft='fa fa-plus'
					action={canCreate ? createFunction : () => {}}
					href={createLink}
					variant={canCreate ? 'primary' : 'secondary'}
					// state={canCreate ? null : 'disabled'}
					color={canCreate ? 'blue' : 'gray'}
					disabled={!canCreate}
				/>
			</div>
			{select}

			{/* ONLY SHOW THIS IF ONE OR MORE ITEMS ARE SELECTED */}
			{view == 'table' && selected?.length > 0 && (
				<div className={css['actions']}>
					<Select
						// REPLACE WITH OPTIONS COMING FROM PROPS
						options={options}
						placeholder='Bulk Actions'
						className={css['custom-select']}
						onChange={setAction}
						isSearchable={false} // to hide keyboard on mobile
					/>
					{/* REPLACE '5' WITH THE NUMBER OF SELECTED ITEMS.
                ADD A CONDITION TO NOT RENDER 's' AT THE END IF ONLY 1 IS SELECTED (ALREADY DONE; TAKE A LOOK AT TableFilterable COMPONENT 
                */}
					<Button
						label={`Apply 
								on ${selected.length} ${dataName}s`}
						action={() => action.value(selected)}
					/>
				</div>
			)}
		</div>
	)
}
